var map = {
	"./banano-bet-dark-wallpaper.png": 195,
	"./banano-bet-light-wallpaper.png": 196,
	"./banano-bet-logo-yh.svg": 197,
	"./banano-bet-logo-yh_xmas.svg": 198,
	"./banano-bet-logo-yv.svg": 199,
	"./banano-bet-logo-yv_xmas.svg": 200,
	"./banano-bet-preview.jpg": 201,
	"./banano.svg": 202,
	"./bbet-placeholder1.jpg": 203,
	"./coin-base.jpg": 204,
	"./discord-logo.png": 205,
	"./emoji/aww.png": 206,
	"./emoji/bbetdice.png": 207,
	"./emoji/bebe.png": 208,
	"./emoji/biblethump.png": 209,
	"./emoji/heart.png": 210,
	"./emoji/hng.png": 211,
	"./emoji/justripe.png": 212,
	"./emoji/kappa.png": 213,
	"./emoji/pepekms.png": 214,
	"./emoji/pepelovebananobet.png": 215,
	"./emoji/raugh.png": 216,
	"./emoji/smug.png": 217,
	"./emoji/thinkingeyes.png": 218,
	"./emoji/thonk.png": 219,
	"./emoji/thonkerguns.png": 220,
	"./emoji/thonkwat.png": 221,
	"./emoji/wen.png": 222,
	"./favicon.png": 223,
	"./sample_monkey.svg": 224,
	"./slider-handle-2.svg": 225,
	"./slider-handle-3.svg": 226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;